import YAML from '../../services/yaml';

// If sweep.displayName is not set, it'll use the name field from sweep config json
export function getSweepDisplayName(
  sweep?: {
    name: string;
    displayName?: string | null;
    config?: string;
  } | null
): string {
  if (sweep == null) {
    return '';
  }
  if (sweep.displayName != null) {
    return sweep.displayName;
  }
  if (sweep.config != null) {
    const config = YAML.parse(sweep.config);
    const nameFromConfig = config.name?.value || config.name;
    if (nameFromConfig && typeof nameFromConfig === 'string') {
      return nameFromConfig;
    }
  }
  return sweep.name;
}
